import type { NewsArticle } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function RelatedArticles({ list }: { list: NewsArticle[] }) {
  if (list.length === 0) return null;

  return (
    <section aria-label="相关推荐" className="mt-12">
      <SectionHeading title="相关推荐" subtitle="和这篇内容相关的其他进展" icon="ri-links-line" />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((item) => (
          <NewsCard key={item.id} article={item} />
        ))}
      </div>
    </section>
  );
}